// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"1b63200d","799":"54937b11"}[chunkId] + ".chunk.css";
};